import { rpc } from './ws';

export interface ReferralSummary {
  enabled: boolean;
  code: string;
  link: string;
  invited: number;
  earnedUsd: number;
  paidUsd: number;
  balanceUsd: number;
  minWithdrawUsd: number;
  canWithdraw: boolean;
}

export interface ReferralEarning {
  id: string;
  /** transfer | card_issue | card_topup | qr | onramp | offramp */
  source: string;
  amountUsd: number;
  paid: boolean;
  createdAt: string;
}

export interface ReferralPayout {
  id: string;
  amountUsd: number;
  /** requested | sending | paid | failed */
  status: string;
  txHash: string | null;
  createdAt: string;
  paidAt: string | null;
}

export const fetchReferral = () => rpc<ReferralSummary>('referral.summary');

export const fetchReferralEarnings = () =>
  rpc<{ earnings: ReferralEarning[] }>('referral.earnings').then((r) => r.earnings);

export const fetchReferralPayouts = () =>
  rpc<{ payouts: ReferralPayout[] }>('referral.withdrawals').then((r) => r.payouts);

/** The destination is a wallet id, never an address — the server reads the
 *  address from the wallet it owns, so a stolen session cannot redirect it. */
export const withdrawReferral = (walletId: string, reauthToken?: string) =>
  rpc<{ payout: ReferralPayout }>('referral.withdraw', { walletId, reauthToken });
